import { isAxiosError } from 'axios';

import { PromoCode } from '@videoblocks/subscription-service-client';
import { LoggerFactory } from '@videoblocks/typescript-logger';

import { promoApi } from './subscriptionServiceConfig';

const logger = LoggerFactory.create('PromoCodesApi');

const getPromoCodeByCode = async (code: string): Promise<PromoCode | null> => {
    try {
        const result = await promoApi.getPromoCodes({ state: 'redeemable' });
        const promoCodes = result.data ?? [];
        return promoCodes.find((promo) => promo.code === code) ?? null;
    } catch (error) {
        if (isAxiosError(error)) {
            logger.warn({ error, code }, 'Error fetching promo codes');
        } else {
            logger.error({ error, code }, 'Unexpected error fetching promo codes');
        }
        return null;
    }
};

export const PromoCodesApi = {
    getPromoCodeByCode,
};
